"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var NewsBarModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsBarModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const merge_1 = __importDefault(require("lodash/merge"));
const backoffice_1 = require("../../dsl/backoffice");
const services_1 = require("../../services");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * TODO:
 *   - Fix order of properties/methods/getters/setters.
 *   - Add missing JSDoc blocks.
 *
 * Component that contains a complete questionnaire needed to **EDIT** the `NewsBarModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let NewsBarModuleForm = NewsBarModuleForm_1 = class NewsBarModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        this.DashmixIconName = backoffice_1.DashmixIconName;
        this.newItem = { label: '', related: null, externalUrl: '' };
        this.newsBarConfig = form_2.newsBarConfig;
        // Font size constants
        this.MIN_FONT_SIZE = 12;
        this.MAX_FONT_SIZE = 20;
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = NewsBarModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.NewsBar,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            color: form_2.NewsBarColor.Brand,
            fontSize: 14,
            backgroundColor: _contracts_1.ModuleBackgroundColor.None,
            background: '',
            items: []
        };
    }
    get color() {
        return this._content.color;
    }
    set color(value) {
        if (!value) {
            return;
        }
        this._content.color = value;
    }
    get colorClass() {
        if (!this.color) {
            return '';
        }
        return this.newsBarConfig[this.color] ? this.newsBarConfig[this.color].bgClass : '';
    }
    /**
     * Options for the `<DashmixSelect name="color">`.
     */
    get colorOptions() {
        // For some reason this enum in Object.values returns array of values and keys (one lower case, second capitalize),
        // That's why this method with set and mapping to lower case.
        return [...new Set(Object.values(form_2.NewsBarColor).map(value => `${value}`.toLowerCase()))]
            .map(value => {
            return {
                label: this.$t('forms.newsBar.colors.' + value),
                value: value
            };
        });
    }
    get fontSize() {
        return this._content.fontSize;
    }
    set fontSize(value) {
        if (!value || value <= 0) {
            return;
        }
        this._content.fontSize = value;
    }
    /**
     * Font size options`.
     */
    get fontSizeOptions() {
        const options = [];
        for (let i = this.MIN_FONT_SIZE; i <= this.MAX_FONT_SIZE; i++) {
            options.push(i);
        }
        return options
            .map(value => {
            return {
                label: value,
                value: value
            };
        });
    }
    addNewItem() {
        this._content.items = [...this._content.items, { ...JSON.parse(JSON.stringify(this.newItem)) }];
    }
    deleteItem(index) {
        const itemsCopy = [...this._content.items];
        itemsCopy.splice(index, 1);
        this._content.items = itemsCopy;
    }
    findItemSource(index) {
        this.pickRelated(services_1.Picker.Content, (source) => this.setItemSource(index, source));
    }
    hasItemList(index) {
        return !!this._content.items[index] && !!this._content.items[index].related &&
            !!this._content.items[index].related.value;
    }
    /**
     * @inheritDoc
     * @override
     */
    afterInitialContentSetup() {
        this.$nextTick(() => {
            for (let i = 0; i < this._content.items.length; i++) {
                if (this.hasItemList(i)) {
                    this.describe(this._content.items[i].related);
                }
            }
        });
    }
    /**
     * @inheritDoc
     * @override
     */
    setInitialContent() {
        const content = merge_1.default(this.initialContent, this._content);
        if (content.items.length === 0) {
            content.items.push(JSON.parse(JSON.stringify(this.newItem)));
        }
        this._content = content;
    }
    setItemSource(index, source) {
        const itemsCopy = [...this._content.items];
        itemsCopy[index].related = source;
        this.describe(source);
        this._content.items = itemsCopy;
    }
};
NewsBarModuleForm = NewsBarModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'NewsBarModuleForm',
        components: {
            DashmixButton: backoffice_1.DashmixButton,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixSelect: backoffice_1.DashmixSelect,
            FormErrors: form_2.FormErrors
        },
        template: `
    <div>
    <!-- Colors -->
    <div class="form-group">
      <label for="color">{{ $t('forms.newsBar.colorsLabels') }}</label>
      <div class="news-bar__select">
        <DashmixSelect
          :model.sync="color" name="color"
          :options="colorOptions" :searchable="false" />
        <div class="news-bar__selected-color" :class="colorClass" />
      </div>
    </div>

    <!--Font Size -->
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label for="font">{{ $t('forms.newsBar.fontSizeLabel') }}</label>
          <div>
            <DashmixSelect
              :model.sync="fontSize" name="font"
              :options="fontSizeOptions" :searchable="false" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group mb-4">
      <label for="list_value" class="d-block">{{ $t('forms.newsBar.elements') }}</label>

      <template v-for="(item, index) in _content.items">
        <div class="bg-light py-3 row mx-0 my-3">
          <div class="col-11 p-0">
            <div class="row mx-0">
              <div class="col-12 col-md-6">
                <label for="list_value" class="d-block">{{ $t('forms.newsBar.label') }}</label>
                <DashmixInput size="small" :model.sync="item.label" :name="'tab-label-' + index" />
              </div>
              <div class="col-12 col-md-6">
                <label for="list_value" class="d-block">{{ $t('forms.newsBar.externalUrl') }}</label>
                <DashmixInput size="small" :model.sync="item.externalUrl" :name="'tab-externalUrl-' + index" />
              </div>

              <div class="col-12 col-md-6">
                <label for="list_value" class="d-block">{{ $t('forms.newsBar.links') }}</label>
                <div>
                  <DashmixButton size="small" variant="alt" :icon="DashmixIconName.SearchSolid"
                                 :label="$t('forms.shared.search')"
                                 @click="() => findItemSource(index)" />

                  <p v-if="hasItemList(index)" class="mb-0 mt-2">
                    <strong class="mr-2">{{ $t('forms.newsBar.chosenLink') }}</strong>{{ description(item.related) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-1 d-flex align-items-center p-0">
            <DashmixButton variant="icon" :icon="DashmixIconName.TrashSolid" theme="danger"
                           @click="() => deleteItem(index)" />
          </div>
        </div>
      </template>

      <div class="form-group col-12 col-md-6">
        <label for="color">{{ $t('forms.shared.backgroundColor') }}</label>
        <DashmixSelect :model.sync="_content.backgroundColor" name="backgroundColor"
                       :placeholder="$t('forms.shared.backgroundColorPlaceholder')"
                       :options="backgroundColorOptions" :searchable="false"/>
        <DashmixInput v-if="isCustomColor" type="color" :model.sync="_content.background" name="background"/>
      </div>

      <DashmixButton :icon="DashmixIconName.PlusSolid" variant="icon"
                     :label="$t('forms.newsBar.addNew')" @click="addNewItem" />
    </div>

    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3" />
    </div>
  `
    })
], NewsBarModuleForm);
exports.NewsBarModuleForm = NewsBarModuleForm;
//# sourceMappingURL=NewsBar.form.js.map